import { firestore } from 'firebase';
import OrderBread, { OrderBreadEntity } from 'src/firebase/db/OrderBreads';

export const getOrderBread = (id: string) => OrderBread.getOrderBread(id);
export const getOrderBreads = (shopId: string) => OrderBread.getOrderBreads(shopId);

export const getNotificationOrderBreads = (
  shopId: string,
  notificationRef: firebase.firestore.DocumentReference,
) => {
  return OrderBread.getNotificationOrderBreads(shopId, notificationRef);
};

export const getDayOrderBreads = (shopId: string, startDate: Date, endDate: Date) => {
  return OrderBread.getDayOrderBreads(shopId, startDate, endDate);
};

export const createOrderBread = (query: OrderBreadEntity) => OrderBread.create(query);

export const deleteOrderBread = (orderBreadId: string) => OrderBread.delete(orderBreadId);
